/* ATARA header: hover-intent mega panels, keyboard + touch support, gift-finder deep links */
(function () {
  'use strict';
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var desk = window.matchMedia('(min-width: 990px)');
  var noHover = window.matchMedia('(hover: none)');

  function initMega() {
    var header = document.querySelector('[data-header]');
    if (!header || header._mega) return; header._mega = true;
    var items = $$('[data-mega-item]', header);
    if (!items.length) return;
    var scrim = document.querySelector('.mega-scrim');
    if (!scrim) { scrim = document.createElement('div'); scrim.className = 'mega-scrim'; document.body.appendChild(scrim); }
    var current = null, tOpen = null, tClose = null;
    header.querySelector('.mnav').addEventListener('mouseenter', function () {
      $$('.mega img[loading="lazy"]', header).forEach(function (i) { i.loading = 'eager'; });
    }, { once: true });

    function trig(it) { return it.querySelector('[data-mega-trigger]'); }
    function open(it) {
      clearTimeout(tClose);
      if (current === it) return;
      if (current) {
        [current, it].forEach(function (x) { x.querySelector('.mega').style.transition = 'none'; });
        current.classList.remove('is-open'); trig(current).setAttribute('aria-expanded', 'false');
      }
      $$('img[loading="lazy"]', it).forEach(function (i) { i.loading = 'eager'; });
      current = it;
      it.classList.add('is-open'); trig(it).setAttribute('aria-expanded', 'true');
      header.classList.add('is-solid'); scrim.classList.add('is-on');
    }
    function close() {
      clearTimeout(tOpen);
      if (!current) return;
      current.classList.remove('is-open'); trig(current).setAttribute('aria-expanded', 'false');
      current = null;
      header.classList.remove('is-solid');
      $$('.mega', header).forEach(function (m) { m.style.transition = ''; });
      scrim.classList.remove('is-on');
    }
    items.forEach(function (it) {
      it.addEventListener('mouseenter', function () {
        if (!desk.matches || noHover.matches) return;
        clearTimeout(tClose); clearTimeout(tOpen);
        tOpen = setTimeout(function () { open(it); }, current ? 40 : 140);
      });
      it.addEventListener('mouseleave', function () {
        clearTimeout(tOpen);
        tClose = setTimeout(close, 260);
      });
      trig(it).addEventListener('click', function (e) {
        if (!desk.matches) return;
        if (current !== it && (noHover.matches || e.detail === 0)) { e.preventDefault(); open(it); }
      });
      trig(it).addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') { e.preventDefault(); open(it); var f = it.querySelector('.mega a'); if (f) f.focus(); }
      });
      it.addEventListener('focusout', function (e) {
        if (current === it && !it.contains(e.relatedTarget)) tClose = setTimeout(close, 120);
      });
      it.addEventListener('focusin', function () { clearTimeout(tClose); });
    });
    scrim.addEventListener('mouseenter', close);
    scrim.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && current) { var t = trig(current); close(); t.focus(); }
    });
    if (desk.addEventListener) desk.addEventListener('change', close);
  }

  function deepLinkFinder() {
    var occ = new URLSearchParams(window.location.search).get('occasion');
    if (!occ) return;
    var btn = $$('[data-finder] .opt[data-group="occasion"]').filter(function (b) { return b.getAttribute('data-value') === occ; })[0];
    if (btn) btn.click();
  }

  function init() { initMega(); deepLinkFinder(); }
  if (document.readyState === 'complete') init(); else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', function (e) {
    var h = e.target.querySelector('[data-header]');
    if (h) { h._mega = false; initMega(); }
  });
})();